import {createContext} from 'react';

// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import {FloatingFocusManager, FloatingPortal} from '@floating-ui/react';

import type {DropdownBaseProps} from '@pb/kit-component-dropdown-v2';
import type {ComponentProps, Context} from 'react';


export type DropdownMenuContextType = {
    bodyComponent?: DropdownBaseProps['bodyComponent'],
    type?: 'ABSOLUTE' | 'FIXED',
    maxHeight?: number,
    maxWidth?: number,
    portalProps?: ComponentProps<typeof FloatingPortal>,
    floatingFocusManagerProps?: Partial<ComponentProps<typeof FloatingFocusManager>>,
    shouldUnmount?: boolean,
    onItemSelect?: () => void,
};

const DEFAULT_CONTEXT = {} as const;

export const DropdownMenuContext: Context<DropdownMenuContextType> = createContext<DropdownMenuContextType>(
    DEFAULT_CONTEXT,
);

DropdownMenuContext.displayName = 'DropdownMenuContext';
